import { graphql } from '@/client/services/api/graphql/gql';

export const getOneExpertQuery = graphql(`
  query GetOneExpert($expertId: String!) {
    getOneExpert(expertId: $expertId) {
      color
      companyId
      creatorId
      description
      enabled
      id
      name
      negativeFeedback
      positiveFeedback
      resources {
        addedBy
        extensionName
        extensionType
        id
        path
        source
        sourceId
        downloadLink
        isFolder
        fileCount
        parentFolder
        lastSynced
        lastSyncSuccessful
        lastSyncErrorMessage
        __typename
      }
      resourcesCount
      responses
      segmentation {
        parent {
          parent {
            segmentationId
            segmentationName
            segmentationType
            __typename
          }
          segmentationId
          segmentationName
          segmentationType
          __typename
        }
        segmentationId
        segmentationName
        segmentationType
        __typename
      }
      __typename
    }
  }
`);
